export enum RentScheduleEntryType {
  Days = "days",
  Weeks = "weeks",
  Months = "months",
  Years = "years",
}
